import { Underconstruction } from "../WorkerComp/Utils"
export default function Request(){
    // make request for any project
    // work school project
    // should have request name
    // request description
    // request image
    
    return(
        <>
        <Underconstruction name="Request"/>
        </>
       )
}